__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/984f726e6e39a844ce899aa988894389d63fbdee/_next/";